import * as React from 'react';
import logo from '../black-logo.svg';
import './Footer.css';
class Footer extends React.PureComponent {
  render(): JSX.Element {
    return (
      <footer>
        <div className="footer-section pad-40">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <h2 className="ft-title">
                  <span>Keep in touch</span>
                </h2>
                <div className="footer-widget-1 address">
                  <ul>
                    <li>
                      <i className="fa fa-home" />Bidau-Lecidere  Dili Timor-Leste</li>
                    <li>
                      <i className="fa fa-envelope" />
                      <a href="mailto:proema.timorleste@gmail.com">proema.timorleste@gmail.com</a>
                    </li>
                    <li>
                      <i className="fa fa-phone" />+670 7862 8966</li>
                    <li>
                      <i className="fa fa-globe" />
                      <a href="https://pro-ema.org" target="_blank">www.pro-ema.org</a>
                    </li>
                  </ul>
                </div>
              </div>
              {/*/footer-1*/}
              <div className="col-md-4">
                <div className="footer-widget-2 text-center">
                  <img src={logo} alt="footer-logo" />
                  <p>Empowering Program for Young Adolescent Women</p>
                </div>
                <div className="footer-social">
                  <div className="social-icon">
                    <ul>
                      <li>
                        <a title="Facebook" href="https://www.facebook.com/proema.timorleste/" target="_blank">
                          <i className="fa fa-facebook" />
                        </a>
                      </li>
                      <li>
                        <a title="Instagram" href="https://www.instagram.com/proema.timorleste/" target="_blank">
                          <i className="fa fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a title="Trip Advisor" href="https://www.tripadvisor.com.br/Restaurant_Review-g297517-d14001055-Reviews-Pro_Ema_Restaurant_School-Dili_Dili_District.html" target="_blank">
                          <i className="fa fa-tripadvisor" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <h2 className="ft-title">
                  <span>Latest tweet</span>
                </h2>
                <div id="twitter-feed" className="twitter-feed">
                  <div className="tweet" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>);
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.tsx